import { ValidationStringMap } from '@bingads-webui/validation-string-map';
import addressTaxFormLegacyStrings from '@bingads-webui-cc-react/address-tax-form-legacy-strings';
import ablEnforcementLegacyStrings from '@bingads-webui-cc-react/abl-enforcement-legacy-strings';
import { LegacyStrings as DialogsLegacyStrings } from '@bingads-webui-cc-react/dialogs';

import { legacyStrings } from './legacy-strings-for-new-i18n';

export const aggregateStrings = {
  ...legacyStrings,
  ...ValidationStringMap,
  ...addressTaxFormLegacyStrings,
  ...ablEnforcementLegacyStrings,
  ...DialogsLegacyStrings.ConfirmNoGSTINDialog,
  ...DialogsLegacyStrings.ConfirmTaxCertificateDialog,
};
